const defaultPatientMessage: PatientMessage = {
  wieldyId: "",
  lastClaimDate: null,
  lastPaymentDate: null,
  name: null,
  wieldyFirstName: null,
  wieldyMiddleName: null,
  wieldyLastName: null,
  ssn: null,
  dob: null,
  phoneNumber: null,
  email: null,
  address: null,
  city: null,
  state: null,
  zipCode: null,
  practiceId: null,
  responsibleName: null,
  responsibleSsn: null,
  responsibleMobilePhone: null,
  responsibleWorkPhone: null,
  responsibleEmail: null,
  responsibleAddress: null,
  responsibleCity: null,
  responsibleState: null,
  responsibleZipCode: null,
  source: null,
};

export function constructPatientMessage(
  partial?: Partial<PatientMessage>,
): PatientMessage {
  return {
    ...defaultPatientMessage,
    ...partial,
  };
}
